const scrollTop = document.getElementById('scroll__top');

if (scrollTop) {
  scrollTop.addEventListener('click', function () {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  });

  // Throttled via requestAnimationFrame + passive flag so it never blocks scrolling
  let _backToTopTicking = false;
  window.addEventListener('scroll', function () {
    if (!_backToTopTicking) {
      requestAnimationFrame(function () {
        if (window.scrollY > 300) {
          scrollTop.classList.add('active');
        } else {
          scrollTop.classList.remove('active');
        }
        _backToTopTicking = false;
      });
      _backToTopTicking = true;
    }
  }, { passive: true });
}